var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99995 9.99995C4.99995 10.3944 5.31973 10.7142 5.71423 10.7142C6.10873 10.7142 6.42852 10.3944 6.42852 9.99995C6.42852 9.60545 6.10873 9.28566 5.71423 9.28566C5.31973 9.28566 4.99995 9.60545 4.99995 9.99995Z",
    stroke: "#828282",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.714233 9.99995C0.714233 10.3944 1.03403 10.7142 1.42852 10.7142C1.823 10.7142 2.1428 10.3944 2.1428 9.99995C2.1428 9.60545 1.823 9.28566 1.42852 9.28566C1.03403 9.28566 0.714233 9.60545 0.714233 9.99995Z",
    stroke: "#828282",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99995 5.71423C4.99995 6.10873 5.31973 6.42852 5.71423 6.42852C6.10873 6.42852 6.42852 6.10873 6.42852 5.71423C6.42852 5.31973 6.10873 4.99995 5.71423 4.99995C5.31973 4.99995 4.99995 5.31973 4.99995 5.71423Z",
    stroke: "#828282",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.714233 5.71423C0.714233 6.10873 1.03403 6.42852 1.42852 6.42852C1.823 6.42852 2.1428 6.10873 2.1428 5.71423C2.1428 5.31973 1.823 4.99995 1.42852 4.99995C1.03403 4.99995 0.714233 5.31973 0.714233 5.71423Z",
    stroke: "#828282",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99995 1.42852C4.99995 1.823 5.31973 2.1428 5.71423 2.1428C6.10873 2.1428 6.42852 1.823 6.42852 1.42852C6.42852 1.03403 6.10873 0.714233 5.71423 0.714233C5.31973 0.714233 4.99995 1.03403 4.99995 1.42852Z",
    stroke: "#828282",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.714233 1.42852C0.714233 1.823 1.03403 2.1428 1.42852 2.1428C1.823 2.1428 2.1428 1.823 2.1428 1.42852C2.1428 1.03403 1.823 0.714233 1.42852 0.714233C1.03403 0.714233 0.714233 1.03403 0.714233 1.42852Z",
    stroke: "#828282",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.45c30e4d.svg";
export { ForwardRef as ReactComponent };